import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './CTAVariation.css';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import { get, getPageThemeColors, getColorByTheme, canUseDOM, getDictionaryItem } from '../../utils';
import HappinessMeterWidget from '../HappinessMeterWidget/HappinessMeterWidget';
import CodeSnippet from '../CodeSnippet/CodeSnippet';
import { useScroll } from './useScroll';
import RouterLink from '../atoms/RouterLink';
import { useModal } from '../atoms/Modal/useModal';
import Modal from '../atoms/Modal/Modal';
var transition = '0.3s linear';
var CTAVariation = function CTAVariation(_ref) {
  var fields = _ref.fields,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rightLinks = get(fields, 'data.item.rightLinks.targetItems') || [];
  var leftLinks = get(fields, 'data.item.leftLinks.targetItems') || [];
  var centerLinks = get(fields, 'data.item.centerLinks.targetItems') || [];
  var dictionary = get(fields, 'data.dictionary', {
    dictionaryValues: []
  });
  var happinessMeterText = getDictionaryItem(dictionary, 'happinessMeter') || '';
  var _useModal = useModal(),
    isShown = _useModal.isShown,
    toggle = _useModal.toggle;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    iframeUrl = _React$useState2[0],
    setIframeUrl = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  var scrollDown = useScroll(50);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isVdsite = _React$useState6[0],
    setIsVdsite = _React$useState6[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    '--m113-cta-variation-background-color': BackgroundColorHex,
    '--m113-cta-variation-background-active-color': ActiveColorHex,
    '--m113-cta-variation-color': ColorHex
  } : {
    '--m113-cta-variation-background-color': selectedPrimaryColor,
    '--m113-cta-variation-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-cta-variation-color': getColorByTheme(selectedPrimaryColor)
  };
  if (fields && !fields.data) {
    console.info('CTAVariation: check fields.data settings');
    return /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, " [CTAVariation component: something went wrong]");
  }
  if (fields && fields.data && !fields.data.item) {
    console.info('CTAVariation: check fields.data.item settings');
    return /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, " [CTAVariation component: something went wrong]");
  }
  if (!fields) {
    console.info('CTAVariation component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [CTAVariation component is empty: please provide data source]");
    }
    return null;
  }
  var renderLink = function renderLink(el, placement) {
    var id = get(el, 'id');
    var title = get(el, 'title.jss.value');
    var tooltipText = get(el, 'toolTip.jss.value') || '';
    var name = get(el, 'name') || 'name is not provided';
    var icon = get(el, 'svgIcon.targetItem.svg.jss.value');
    var linkHref = get(el, 'link.jss.value.href');
    var linkType = get(el, 'link.jss.value.linktype');
    var linkTarget = get(el, 'link.jss.value.target');
    var isPopup = get(el, 'isPopup.jss.value') || false;
    var code = get(el, 'code.jss.value');
    var isDesktop = get(el, 'isDesktop.jss.value') || false;
    var iframeUrl = get(el, 'iFrameLink.jss.value') || '';
    var isIframe = Boolean(iframeUrl) || false;
    var tooltipLocationForPopup = {
      right: "".concat(rtl ? 'right' : 'left'),
      left: "".concat(rtl ? 'left' : 'right'),
      center: 'top'
    };
    if (isPopup) {
      return /*#__PURE__*/React.createElement("div", {
        className: "m113-sticky-banner-card m113-sticky-banner-card--code-snippet ".concat(isDesktop ? 'm113-sticky-banner-card--desktop-only' : ''),
        "data-tip": "",
        "data-for": "tooltip-cd-".concat(id, "-").concat(placement)
      }, /*#__PURE__*/React.createElement("button", {
        className: "m113-sticky-banner-link chat",
        key: id,
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['openPopupAnalytics'], params), name);
        }
      }, icon ? /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: icon
        },
        className: "icon"
      }) : /*#__PURE__*/React.createElement(React.Fragment, null), title ? /*#__PURE__*/React.createElement("span", {
        className: "m113-card__title"
      }, title) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(CodeSnippet, {
        fields: {
          data: {
            item: {
              name: title,
              code: {
                jss: {
                  value: code
                }
              },
              scripts: {
                jss: {
                  value: ''
                }
              }
            }
          }
        },
        params: params
      })), tooltipText ? /*#__PURE__*/React.createElement(ReactTooltip, {
        id: "tooltip-cd-".concat(id, "-").concat(placement),
        place: tooltipLocationForPopup[placement],
        type: "light",
        effect: "solid",
        className: "m113-sticky-banner-card-tooltip"
      }, /*#__PURE__*/React.createElement("span", null, tooltipText)) : null);
    } else if (isIframe) {
      return /*#__PURE__*/React.createElement("div", {
        className: "m113-sticky-banner-card m113-sticky-banner-card--iframe ".concat(isDesktop ? 'm113-sticky-banner-card--desktop-only' : ''),
        "data-tip": "",
        "data-for": "tooltip-iframe-".concat(id, "-").concat(placement)
      }, /*#__PURE__*/React.createElement("button", {
        className: "m113-sticky-banner-link",
        key: id,
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['openPopupAnalytics'], params), name);
          setIframeUrl(iframeUrl);
          toggle();
        }
      }, icon ? /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: icon
        },
        className: "icon"
      }) : /*#__PURE__*/React.createElement(React.Fragment, null), title ? /*#__PURE__*/React.createElement("span", {
        className: "m113-card__title"
      }, title) : /*#__PURE__*/React.createElement(React.Fragment, null)), tooltipText ? /*#__PURE__*/React.createElement(ReactTooltip, {
        id: "tooltip-iframe-".concat(id, "-").concat(placement),
        place: tooltipLocationForPopup[placement],
        type: "light",
        effect: "solid",
        className: "m113-sticky-banner-card-tooltip"
      }, /*#__PURE__*/React.createElement("span", null, tooltipText)) : null);
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "m113-sticky-banner-card ".concat(isDesktop ? 'm113-sticky-banner-card--desktop-only' : ''),
        "data-tip": "",
        "data-for": "tooltip-link-".concat(id, "-").concat(placement)
      }, /*#__PURE__*/React.createElement(RouterLink, {
        className: "m113-sticky-banner-link",
        href: linkHref,
        key: id,
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['clickAnalytics'], params), name);
        },
        dataCy: "multifunctional-card-link",
        linktype: linkType,
        linksTarget: linkTarget
      }, icon ? /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: icon
        },
        className: "icon"
      }) : /*#__PURE__*/React.createElement(React.Fragment, null), title ? /*#__PURE__*/React.createElement("span", {
        className: "m113-card__title"
      }, title) : /*#__PURE__*/React.createElement(React.Fragment, null)), tooltipText ? /*#__PURE__*/React.createElement(ReactTooltip, {
        id: "tooltip-link-".concat(id, "-").concat(placement),
        place: "top",
        type: "light",
        effect: "solid",
        className: "m113-sticky-banner-card-tooltip"
      }, /*#__PURE__*/React.createElement("span", null, tooltipText)) : null);
    }
  };
  var renderHappinessMeterWidget = function renderHappinessMeterWidget() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HappinessMeterWidget, {
      formUrl: "/HappinessMeterForm.aspx",
      analytics: eventsAnalytics,
      params: params,
      CTAVariation: true,
      customButton: true
    }), happinessMeterText ? /*#__PURE__*/React.createElement(ReactTooltip, {
      id: "Happiness-Meter-tooltip",
      place: "".concat(rtl ? 'right' : 'left'),
      type: "light",
      clickable: true,
      effect: "solid",
      className: "m113-sticky-banner-card-tooltip"
    }, /*#__PURE__*/React.createElement("span", null, happinessMeterText)) : null);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, leftLinks.length || centerLinks.length || rightLinks.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container m113-sticky-banner ".concat(scrollDown ? 'collapsed' : ''),
    style: variables
  }, leftLinks.length ? /*#__PURE__*/React.createElement("div", {
    className: "m113-sticky-banner-bar left-bar"
  }, renderHappinessMeterWidget(), leftLinks.map(function (item) {
    return renderLink(item, 'left');
  })) : null, centerLinks.length ? /*#__PURE__*/React.createElement("div", {
    className: "m113-sticky-banner-bar center-bar"
  }, centerLinks.map(function (item) {
    return renderLink(item, 'center');
  })) : null, rightLinks.length ? /*#__PURE__*/React.createElement("div", {
    className: "m113-sticky-banner-bar right-bar"
  }, rightLinks.map(function (item) {
    return renderLink(item, 'right');
  })) : null), iframeUrl && /*#__PURE__*/React.createElement(Modal, {
    isShown: isShown,
    hide: function hide() {
      if (isShown) {
        setLoading(true);
        // setIframeUrl('');
      }
      toggle();
    }
  }, loading ? /*#__PURE__*/React.createElement("div", {
    className: "modal-loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null))))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("iframe", {
    title: "".concat(iframeUrl, "-iframe"),
    width: "100%",
    onLoad: function onLoad() {
      return setLoading(false);
    },
    frameBorder: "0",
    allowFullScreen: false,
    scrolling: "auto",
    className: "cta-variation-iframe",
    src: iframeUrl,
    "data-cy": "cta-variation-iframe"
  }))) : null);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1fy6usu";
var ltrStyles = "l1ld3uw2";
var rtlStyles = "rx03w1s";
export default CTAVariation;